import { useDialog, String_t, postMessageClose } from "mfe-lib-bfo-shared";

export const useDefaultApiError = () => {
    const { openDialog } = useDialog();

    const title = String_t("ui.dialogErrors.somethingIsntRight.title", "stitcher");
    const message = String_t("ui.dialogErrors.somethingIsntRight.description", "stitcher");
    const buttonLabel = String_t("ui.dialogErrors.somethingIsntRight.buttonLabel", "stitcher");

    return (errorCode: string) => {
        const errorMessage = errorCode ? `${message} [${errorCode}]` : message;

        openDialog({
            title,
            message: errorMessage,
            primaryBtnLabel: buttonLabel,
            iconType: "system-downtime",
            onPrimaryClick: () => {
                console.log("Default Error Dialog clicked");
                postMessageClose();
            },
            onCloseBtn: "primary",
        });
    };
};
